<div class="container-fluid p-0">
<footer class="footer-section">
        <div class="container">
            <div class="footer-content pb-5">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 mb-50">
                        <div class="logo-content">
                            <div class="footer-logo">
                                <a routerLink="/"><img src="images/logo_footer.webp" class="img-fluid" alt="logo"></a>
                            </div>
                            <div class="footer-social-icon">
                                <a routerLink="/"><i class="fab fa-facebook-f facebook-bg"></i></a>
                                <a routerLink="/"><i class="fa-brands fa-youtube"></i></a>
                                <!-- <a routerLink="/"><i class="fab fa-google-plus-g google-bg"></i></a> -->
                                <a routerLink="/"><i class="fa-brands fa-instagram"></i></a>
                                <a routerLink="/"><i class="fa-brands fa-x-twitter"></i></a>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-8 col-lg-8 mb-50">
                        <div class="footer-right">
                            <div class="contact-details">
                            <div class="footer-widget-heading">
                                <h3>{{ 'Contact Details' | translate }}</h3>
                            </div>
                            <div class="footer-text mb-25">
                                <i class="fa-regular fa-envelope"></i>
                                <span>hindiolympiad[at]vishwarang[dot]com</span>
                            </div>
                        </div>
                        <div class="footer-widget">
                            <ul>
                                <li><a routerLink="about-us"><i class="fa-solid fa-arrow-right-long"></i>{{ 'About us' | translate }}</a></li>
                                <!-- <li><a routerLink="/"><i class="fa-solid fa-arrow-right-long"></i> Hindi olympiad 2026 </a></li> -->
                                <!-- <li><a routerLink="/"><i class="fa-solid fa-arrow-right-long"></i>{{ 'Programme' | translate }}</a></li> -->
                                <li><a routerLink="contact-us"><i class="fa-solid fa-arrow-right-long"></i>{{ 'Contact us' | translate }}</a></li>
                            </ul>
                            <ul>
                                <li><a routerLink="/payment-policy"><i class="fa-solid fa-arrow-right-long"></i>{{ 'Payment Policy' | translate }}</a></li>
                                <li><a routerLink="/privacy-policy"><i class="fa-solid fa-arrow-right-long"></i>{{ 'Privacy Policy' | translate }}</a></li>
                                <li><a routerLink="term-and-conditions"><i class="fa-solid fa-arrow-right-long"></i>{{ 'Terms and Conditions' | translate }}</a></li>                                 
                                <li><a routerLink="faq"><i class="fa-solid fa-arrow-right-long"></i>{{ 'FAQs' | translate }}</a></li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="copyright-area">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 text-center text-lg-left">
                        <div class="copyright-text">
                            
                            <p>{{'Copyright'|translate}} © 2025 <b>{{ 'Vishwarang Foundation' | translate }}</b> {{'All rights reserved. Developed by AISECT Infotech' | translate}}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="hits-card">
    
                            <div class="icon-box">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#2f5cf5" stroke-width="1.8">
                                    <path d="M4 17L10 11L14 15L21 8"></path>
                                    <path d="M16 8H21V13"></path>
                                    <path d="M4 21H20"></path>
                                </svg>
                            </div>

                            <div class="content">
                                <div class="content-main">
                                    <h3>Total Hits</h3>
                                    <h1>{{visitorCounter().SiteVisitCounter}}</h1>
                                    <h5>{{visitorCounter().UniqueUserCouter}}</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    </div>   